<template>
	<scroll-view   @scrolltolower='scrolltolower' style="height: 100%;overflow: auto; ">
		 <slot></slot>
	</scroll-view>
</template>

<script>
	export default {
		name:"scroll",
		data() {
			return {
				
			};
		},
		methods:{
			scrolltolower(){
				this.$emit('scrolltolower')
			}
		}
	}
</script>

<style>

</style>
